import React from "react";
import {COMMON_TRANSLATIONS, ROUTES} from "../utils/constants";

import GtfsLogo from "../assets/logo-desktop.svg";
import GtfsLogoDark from "../assets/logo-desktop-dark.svg";

const Footer = () => {
  const selectedLang = typeof window !== "undefined" ? window.localStorage.getItem("lang") || "en" : "en";
  return (
    <footer id="footer">
      <a href={ROUTES.root}>
        <img src={GtfsLogo} alt="Logo" className="light"/>
        <img src={GtfsLogoDark} alt="Logo" className="dark"/>
      </a>
      <a className="link" href={ROUTES.static}>
        {COMMON_TRANSLATIONS[selectedLang].static}
      </a>
      <a className="link" href={ROUTES.realtime}>
        {COMMON_TRANSLATIONS[selectedLang].realtime}
      </a>
      <a className="link" href={ROUTES.gtfs}>
        {COMMON_TRANSLATIONS[selectedLang].gtfs}
      </a>
      <a className="link" href={ROUTES.about}>
        {COMMON_TRANSLATIONS[selectedLang].about}
      </a>
      <span className="copyright">&copy; 2024</span>
    </footer>
  );
};

export default Footer;
